import * as types from '../types';
import initialState from './initialState';

export default function deletedPayMethodReducer(state = initialState.deletedPayMethod, action) {
  switch (action.type) {
    case types.DELETE_PAY_METHOD_FULFILLED: {
      return action.payload.data;
    }
    case types.CLEAR_DELETED_PAY_METHOD: {
      return null;
    }
    default:
      return state;
  }
}
